import { render, staticRenderFns } from "./InfoSplash.vue?vue&type=template&id=75693802&scoped=true&"
import script from "./InfoSplash.vue?vue&type=script&lang=js&"
export * from "./InfoSplash.vue?vue&type=script&lang=js&"
import style0 from "./InfoSplash.vue?vue&type=style&index=0&id=75693802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75693802",
  null
  
)

export default component.exports